import { getI18n } from 'react-i18next';

export const VALIDATION_SUBMARKET_CODE_ALREADY_IN_USE = 'validation.submarket.codeAlreadyInUse';
export const VALIDATION_SUBMARKET_EMPTY_CODE = 'validation.submarket.emptyCode';
export const VALIDATION_SUBMARKET_INVALID_CODE_LENGTH = 'validation.submarket.invalidCodeLength';
export const VALIDATION_SUBMARKET_INVALID_CODE = 'validation.submarket.invalidCode';
export const VALIDATION_SUBMARKET_NAME_ALREADY_IN_USE = 'validation.submarket.nameAlreadyInUse';
export const VALIDATION_SUBMARKET_EMPTY_NAME = 'validation.submarket.emptyName';
export const VALIDATION_SUBMARKET_INVALID_NAME_LENGTH = 'validation.submarket.invalidNameLength';
export const VALIDATION_SUBMARKET_EXISTING_DATA_TEMPLATE = 'validation.submarket.existingTemplate';
export const VALIDATION_SUBMARKET_IMMUTABLE_CODE = 'validation.submarket.immutableCode';
export const VALIDATION_SUBMARKET_IMMUTABLE_NAME = 'validation.submarket.immutableName';
export const ERROR_SUBMARKET_NOT_FOUND = 'submarket.notFound';
export const ERROR_SUBMARKET_CANNOT_BE_DEACTIVATED = 'submarket.noDeactivation';
export const ERROR_SUBMARKET_INVALID_SORT_KEY = 'submarket.sort.invalidField';

export const createSubmarketErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case VALIDATION_SUBMARKET_CODE_ALREADY_IN_USE:
            result = i18n.t('submarkets.error.submarket-code-already-used');
            break;
        case VALIDATION_SUBMARKET_EMPTY_CODE:
            result = i18n.t('submarkets.error.submarket-empty-code');
            break;
        case VALIDATION_SUBMARKET_INVALID_CODE_LENGTH:
            result = i18n.t('submarkets.error.submarket-invalid-code-length', { max: params[0], min: params[1] });
            break;
        case VALIDATION_SUBMARKET_INVALID_CODE:
            result = i18n.t('submarkets.error.submarket-invalid-code');
            break;
        case VALIDATION_SUBMARKET_NAME_ALREADY_IN_USE:
            result = i18n.t('submarkets.error.submarket-name-already-used');
            break;
        case VALIDATION_SUBMARKET_EMPTY_NAME:
            result = i18n.t('submarkets.error.submarket-empty-name');
            break;
        case VALIDATION_SUBMARKET_INVALID_NAME_LENGTH:
            result = i18n.t('submarkets.error.submarket-invalid-name-length', { maxLength: params[0] });
            break;
        case VALIDATION_SUBMARKET_EXISTING_DATA_TEMPLATE:
            result = i18n.t('submarkets.error.submarket-existing-data-template');
            break;
        case VALIDATION_SUBMARKET_IMMUTABLE_CODE:
            result = i18n.t('submarkets.error.submarket-immutable-code');
            break;
        case VALIDATION_SUBMARKET_IMMUTABLE_NAME:
            result = i18n.t('submarkets.error.submarket-immutable-name');
            break;
        case ERROR_SUBMARKET_NOT_FOUND:
            result = i18n.t('submarkets.error.submarket-not-found');
            break;
        case ERROR_SUBMARKET_CANNOT_BE_DEACTIVATED:
            result = i18n.t('submarkets.error.submarket-cannot-be-deactivated');
            break;
        case ERROR_SUBMARKET_INVALID_SORT_KEY:
            result = i18n.t('submarkets.error.submarket-invalid-sort-key', { sortKey: params[0] });
            break;
        default:
            result = undefined;
    }
    return result;
};
